export default __webpack_public_path__ + "static/media/cake17.ccaf1481.jpg";